/* unplugin-vue-components disabled */import i18n from '@/lang';
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.regexp.exec.js";
/* this file is transformed by vux-loader */
/* eslint-disable */
import _asyncToGenerator from "G:/SVN/\u5355\u5C0F\u4E8C/\u6E90\u4EE3\u7801/\u5BA2\u6237\u7AEF\u95E8\u6237/front/smy-toc-vux-cli3/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "G:/SVN/\u5355\u5C0F\u4E8C/\u6E90\u4EE3\u7801/\u5BA2\u6237\u7AEF\u95E8\u6237/front/smy-toc-vux-cli3/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.regexp.exec.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import XButton from "vux/src/components/x-button/index.vue"; // this line is trasformed by vux-loader
import { apilogin, apiforgetpwd, apismsvalid, apisystemsettingByCode } from '@/api';
import { mapState } from 'vuex';
export default {
  props: {
    type: {
      type: [String, Number],
      default: 1
    },
    mobile: [String, Number]
  },
  components: {
    XButton: XButton
  },
  data: function data() {
    return {
      remember: false,
      phone: this.mobile || '',
      password: '',
      verifyPassword: '',
      verify_code: '',
      loading: false,
      wait: 61,
      clear: '',
      epImg: ''
    };
  },
  computed: _objectSpread({}, mapState('globalStore', ['user'])),
  created: function created() {
    var _this = this;
    localStorage.getItem('user', function (e) {
      if (e.result === 'success') {
        var data = JSON.parse(e.data);
        _this.phone = data.phone;
        _this.password = data.password;
      }
    });
    apisystemsettingByCode({
      code: '40008'
    }).then(function (res) {
      if (res.success) {
        _this.epImg = res.data.value;
      }
    });
  },
  methods: {
    // 表单验证
    formValidate: function formValidate() {
      var _this2 = this;
      return new Promise(function (resolve, reject) {
        if (_this2.phone === '') resolve({
          success: false,
          msg: i18n.tc("172")
        });
        if (!_this2.checkPhone(_this2.phone)) resolve({
          success: false,
          msg: i18n.tc("173")
        });
        if (_this2.password === '') resolve({
          success: false,
          msg: i18n.tc("174")
        });
        if (_this2.password.length < 6) resolve({
          success: false,
          msg: i18n.tc("175")
        });
        if (_this2.password !== _this2.verifyPassword) resolve({
          success: false,
          msg: i18n.tc("176")
        });
        if (_this2.verify_code === '') resolve({
          success: false,
          msg: i18n.tc("177")
        });
        resolve({
          success: true
        });
      });
    },
    submit: function submit() {
      if (Number(this.type) === 1) this.invokeApi(apilogin); // 注册
      if (Number(this.type) === 2) this.invokeApi(apiforgetpwd, 'put', i18n.tc("178")); // 重置密码
    },
    // 登录
    invokeApi: function invokeApi(api) {
      var _this3 = this;
      var method = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'post';
      var msg = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : i18n.tc("179");
      this.formValidate().then( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(valid) {
          var res;
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  if (!valid.success) {
                    _context.next = 9;
                    break;
                  }
                  _this3.loading = true;
                  _context.next = 4;
                  return api({
                    type: _this3.type,
                    phone: _this3.phone,
                    password: _this3.password,
                    verify_code: _this3.verify_code
                  }, method);
                case 4:
                  res = _context.sent;
                  setTimeout(function () {
                    _this3.loading = false;
                  }, 300);
                  if (res.success) {
                    _this3.$vux.toast.text(msg);
                    _this3.$router.push({
                      name: 'Login'
                    });
                    // this.rememberPwd() // 记住账号密码
                  } else {
                    _this3.$vux.toast.text(res.message);
                  }
                  _context.next = 10;
                  break;
                case 9:
                  _this3.$vux.toast.text(valid.msg);
                case 10:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    // 记住密码
    rememberPwd: function rememberPwd() {
      if (this.remember) {
        var temp = JSON.stringify({
          phone: this.phone,
          password: this.password
        });
        localStorage.setItem('user', temp, function (e) {
          if (e.result === 'success') {
            console.log('储存user');
          }
        });
      } else {
        localStorage.removeItem('user');
      }
    },
    // 获取验证码
    getVerify: function getVerify() {
      var _this4 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var res;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (_this4.checkPhone(_this4.phone)) {
                  _context2.next = 3;
                  break;
                }
                _this4.$vux.toast.text(i18n.tc("173"));
                return _context2.abrupt("return", false);
              case 3:
                _this4.waitAMoment();
                _this4.wait = 59;
                _context2.next = 7;
                return apismsvalid({
                  phone: _this4.phone
                });
              case 7:
                res = _context2.sent;
                if (!res.success) {
                  _this4.wait = 0;
                  _this4.$vux.toast.text(res.message);
                }
              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    // 计时器
    waitAMoment: function waitAMoment() {
      var _this5 = this;
      this.clear = setTimeout(function () {
        _this5.wait--;
        _this5.waitAMoment();
        if (_this5.wait < 1) {
          clearTimeout(_this5.clear);
          _this5.wait = 61;
        }
      }, 1000);
    },
    // 验证手机类型
    checkPhone: function checkPhone(phone) {
      if (phone.match(/[0-9-()（）]{6,15}/)) {
        return true;
      } else {
        return false;
      }
    }
  }
};